<template>
	<div class="product-details-popup">
		<transition name="right-slide" v-on:after-leave="clearCurrentProductId">
			<div
				v-show="productId"
				class="product-details-wrap"
				:class="{ 'is-loading': productLoaded }"
			>
				<product-details
					v-if="productId"
					:initial-products-count="initialProductsCount"
					:product-id-from-props="productId"
					:before-adding-action="beforeAddingAction"
					@set-product-error="setProductError"
					@set-has-images="setHasImages"
					@hide="hideProductDetails"
					@product-loaded="productLoaded = true"
				/>
			</div>
		</transition>
		<transition name="fade">
			<div
				v-if="productId"
				class="overlay"
				:class="{ 'is-loading': !productLoaded }"
				@click="hideProductDetails"
			/>
		</transition>
	</div>
</template>

<script>
import ProductDetails from './ProductDetails.vue'

export default {
	name: 'ProductDetailsSidebar',

	components: { ProductDetails },

	props: {
		productId: {
			type: String,
			default: ''
		},

		beforeAddingAction: {
			type: Function,
			default: null
		},

		initialProductsCount: {
			type: Number,
			default: 1
		}
	},

	data() {
		return {
			currentProductId: false,
			hasActiveProductImage: true,
			hasProductDetailsError: false,
			productLoaded: true
		}
	},

	async mounted() {
		this.body = document.querySelector('body')

		if (this.productId) {
			this.body.style.overflow = 'hidden'
			this.currentProductId = this.productId
		}
	},

	beforeDestroy() {
		this.body.style.overflow = 'visible'
	},

	computed: {
		trending() {
			return +this.$route.query.trending
		}
	},

	watch: {
		productId(id) {
			if (id) {
				this.body.style.overflow = 'hidden'
				this.currentProductId = this.productId
			} else {
				this.body.style.overflow = 'visible'
			}
		}
	},

	methods: {
		clearCurrentProductId() {
			this.currentProductId = null
		},

		setProductError(val) {
			this.hasProductDetailsError = val
		},

		setHasImages(val) {
			this.hasActiveProductImage = val
		},

		hideProductDetails() {
			this.$emit('close')
		}
	}
}
</script>

<style lang="scss" scoped>
@import './src/assets/styles/variables';

.product-details-popup {
	/deep/ .product-details-price {
		font-size: 20px;
	}

	/deep/ .product-details-alt-price {
		font-size: 16px;
		font-weight: 600;
		color: rgba($white, 0.7);

		.alt-price {
			&::after {
				background-color: rgba($white, 0.7);
			}
		}
	}
}
</style>
